import styled from "@emotion/styled";

import Link from "metabase/core/components/Link";

export const ToastRoot = styled.div`
  display: flex;
  align-items: center;
`;

export const CollectionLink = styled(Link)`
  color: var(--mb-color-brand);
`;
